import { get, post } from '../utils/api';
import { withVoucherTracking } from '../utils/hudVoucherTracking';

export function submitVoucher(voucherId, { username, password }) {
  return withVoucherTracking(
    'submitted_to_tracs',
    'POST /tracs/voucher/{voucherId}',
    () =>
      post(
        `/tracs/voucher/${voucherId}`,
        JSON.stringify({ username, password }),
      ),
  );
}

export function submitTenantEvents(args) {
  return withVoucherTracking(
    'tenant_events_submitted_to_tracs',
    'POST /tracs/tenant-events',
    () => submitTenantEventsUntracked(args),
  );
}

function submitTenantEventsUntracked({
  tenantEventIds,
  username,
  password,
  voucherId,
}) {
  if (!Array.isArray(tenantEventIds) || tenantEventIds.length === 0) {
    return Promise.reject(
      new Error('At least one tenant event id is required'),
    );
  }
  if (!voucherId || String(voucherId).trim() === '') {
    return Promise.reject(new Error('voucherId is required'));
  }
  const body = {
    tenantEventIds,
    username,
    password,
    voucherId: String(voucherId).trim(),
  };
  return post('/tracs/tenant-events', JSON.stringify(body));
}

export function getVoucherStatus({ voucherId, tracsVoucherId }) {
  if (voucherId && tracsVoucherId) {
    return Promise.reject(
      new Error('Provide only voucherId or tracsVoucherId, not both'),
    );
  }
  if (!voucherId && !tracsVoucherId) {
    return Promise.reject(
      new Error('Either voucherId or tracsVoucherId is required'),
    );
  }
  const q = voucherId
    ? `voucherId=${encodeURIComponent(voucherId)}`
    : `tracsVoucherId=${encodeURIComponent(tracsVoucherId)}`;
  return get(`/tracs/voucher/status?${q}`);
}

export function getTenantEventsStatus({ batchId, submissionId }) {
  if (batchId && submissionId) {
    return Promise.reject(
      new Error('Provide only batchId or submissionId, not both'),
    );
  }
  if (!batchId && !submissionId) {
    return Promise.reject(
      new Error('Either batchId or submissionId is required'),
    );
  }
  const q = batchId
    ? `batchId=${encodeURIComponent(batchId)}`
    : `submissionId=${encodeURIComponent(submissionId)}`;
  return get(`/tracs/tenant-events/status?${q}`);
}
